import React, { Component } from 'react';
import { VictoryLabel } from 'victory';

class PieLabel extends Component {
  render() {
    const { datum } = this.props;
    return (
      <g className={`pie_label-${datum.eventKey}`}>
        <VictoryLabel
          {...this.props}
          text={datum.xName}
        />
      </g>
    );
  }
}

export default PieLabel;
